

import {
    init,
    SelectList,
    add,
} from 'one-state-core';

import {
    SET,
    ADD,
    REINIT
} from './types';

import {
    Actions,
} from './actions';

import {
    ErrorObject
} from './errorobject';

export const errorstate = (
    context: any,
    initial?: SelectList<ErrorObject>,
) => {
    const initValue = initial || {
        values: undefined,
    };

    return (
        state: SelectList<ErrorObject> = initValue,
        action: Actions,
    ) => {
        const {
            type,
            payload,
        } = action;
        let updated = state || initValue;
        // Values been assigned to empty array for patient global search
        // Fuctionality.
        if(type === ADD && updated.values === undefined){
            updated.values = [];
        }
        switch (type) {
            case SET:
                updated = init<ErrorObject>(
                    updated,
                    payload as ErrorObject[],
                );
                break;

            case REINIT:
                updated = {
                    values: undefined,
                };
                break;
            case ADD:
                updated = add<ErrorObject>(
                    updated,
                    payload as ErrorObject,
                );
                break;
        }
        return updated;
    }
};
